import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopManageGrade(props) {
  const {open, close} = props;
  const listItems = ['고1', '중3', '중3', '고1', '고1', '고1', '고1'];
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalAlert, setModalAlert] = useState(false);

  return (
    <Modal open={open} close={close} type="com_input com_manage_grade">
      <h2 className="pop_tit">학년관리</h2>
      <div className="content_container scroll">
        <div className="com_scroll_list_wrap">
          <ul className="com_scroll_list pick mb_no">
            {listItems.map((item, index) => (
              <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                {item}
              </li>
            ))}
          </ul>
          <div className='com_btn_wrap bottom'>
            <button className="com_btn gray xxs ">+추가</button>
          </div>
        </div>
        <ul className="com_input_sec">
          <li className="com_input_wrap flex_row btn_wrap">
            <input type="text" className="input w_100" placeholder="" defaultValue={`고3`} />
            <button className="com_btn gray xs">확인</button>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn gray xs" onClick={() => setModalAlert(true)}>
          삭제
        </button>
        <button className="com_btn orange xs">저장</button>
        {/*<button className="com_btn orange xs">등록</button>*/}
      </div>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt">
            등록된 수업이 있어 <br />
            삭제할 수 없습니다.
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </Modal>
  );
}

export default PopManageGrade;
